<template>
  <div class="text-white bg-primary" id="testimonials">
    <div class="container py-5">
      <h2 class="display-4">Testimonials</h2>
      <div id="testimonialCarousel" class="my-3 carousel slide" data-ride="carousel" data-interval="3000">
        <ol class="carousel-indicators" style="bottom: -60px;">
          <li
            data-target="#testimonialCarousel"
            :data-slide-to="i"
            v-for="(testimonialGroup, i) in testimonialGroups"
            :key="i"
          ></li>
        </ol>
        <div class="carousel-inner" style="padding-bottom: 30px;">
          <div class="carousel-item" v-for="(testimonialGroup, i) in testimonialGroups" :key="i">
            <div class="row">
              <div
                class="col-md-4 py-2 py-md-0"
                v-for="testimonial in testimonialGroup"
                :key="testimonial.id"
              >
                <div class="card bg-transparent border-light review">
                  <div class="card-body">
                    <blockquote class="blockquote">
                      <div
                        class="small testimonial-text review__text"
                        v-html="truncate(testimonial.text, 150)"
                      />
                      <footer class="blockquote-footer review__author">
                        {{ testimonial.author }}
                      </footer>
                      
                    </blockquote>
                    <button
                        type="button"
                        class="btn btn-outline-light"
                        data-toggle="modal"
                        :data-target="'#testimonial' + testimonial.id"
                      >
                        Read more
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="testimonial in testimonials"
      :key="testimonial.id"
      class="modal fade"
      :id="'testimonial' + testimonial.id"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-primary">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-html="testimonial.text" />
            <p class="text-muted">
              <em>- {{ testimonial.author }}</em>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#testimonials {
padding-top: 60px;
padding-bottom: 60px;

.container {
    max-width: 1200px;
}

  .card {
    height: 100%;
    position: relative;
    
    .btn-outline-light {
      position: absolute;
      bottom: 20px;
    }
    
    .card-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        
        blockquote {
            width: 100%;
        }
    }
  }
  .review {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        //margin: 20px;
        padding: 10px;
        border: solid 1px white;
        border-radius: 0;
        
        @media (min-width: 992px) {
            padding: 20px;
        }
        
        .review__text {
            margin-bottom: 20px;
            width: 100%;
        }
        
        .review__author {
            display: flex;
            align-items: center;
            text-transform: uppercase;
            letter-spacing: 2px;
            opacity: 0.7;
            margin-bottom: 20px;
            color: white;
            
            &:before {
                content: '';
                display: block;
                width: 20px;
                height: 1px;
                background: rgba(255,255,255,0.7);
                margin-right: 10px;
            }
        }
        
        .btn {
            position: static;
            margin-top: auto;
        }
        
        &:before {
            content: '';
            position: absolute;
            right: 0px;
            bottom: 0px;
            display: block;
            width: 0;
            height: 0;
            border-left: 60px solid transparent;
            border-right: 0px solid transparent;
            border-bottom: 60px solid white;
        }
        
        &:after {
            content: '';
            position: absolute;
            right: -1px;
            bottom: -1px;
            display: block;
            width: 0;
            height: 0;
            border-left: 60px solid transparent;
            border-right: 0px solid transparent;
            border-bottom: 60px solid #231f20;
        }
    }
}

</style>

<script>
import truncate from "truncate";
import { chunk } from "lodash";
import $ from "jquery";

const testimonials = [
  {
    text: `<p>Whether you are looking to buy, sell or rent - look no further. Contact Bricks and Mortar today.</p>
          <p>We have rented our property and leased another through Bricks and Mortar. The process has been equally smooth both ways. Sahil and Madeleine are not only thorough professionals but amazing people. They step into your shoes and understand what your priorities are. They will work tirelessly to get you the best deal. They follow through and ensure that no issue is left unattended.</p>
          <p>We moved to Australia few months ago. Had it not been for Bricks & Mortar, we would have been struggling today. With the kind of professionalism, honesty and market understanding that this team possesses, I have no doubt that Bricks and Mortar will grow from strength to strength. All the Best!</p>`,
    author: "Akanksha Choubey"
  },
  {
    text: `<p>The team at Bricks and Mortar not only helped find the right property for me, they also provide outstanding service that sets them apart from the rest. Both Sahil and Madeleine have shown great amounts of care, empathy and commitment to making sure as a tenant all my needs are met.</p>`,
    author: "Nick Arnott"
  },
  {
    text: `<p>Highly recommended. Sahil really went above and beyond in getting us a suitable tenant for our investment property and he did it on the same day we took ownership of the property. It's not our first experience with property managers but it's been the best by far.</p>`,
    author: "Ashwin Nair"
  },
  {
    text: `<p>My experience with Bricks and Mortar was professional, friendly and reliable. There was no question or request that the team couldn’t meet. I would 100% recommend Bricks and Mortar. <p>`,
    author: "Laura Sellick"
  },
  {
    text: `<p>Extremely professional team. Nothing is ever a hassle - big or small. I have leased several investment properties through them and will continue to do so. Highly recommend for exceptional and reliable service.</p>`,
    author: "Alex Morthorpe"
  },
  {
    text: `<p>Sahil and Madeleine were of great help to me and my partner who were left in a tricky situation by another agent. Their customer service and understanding was incredible. They went above and beyond to assist us. Whether you're a buyer, seller, landlord or tenant - I would highly recommend Bricks and Mortar.</p>`,
    author: "Nigel Moyes"
  },
  {
    text: `<p>Sahil and Madeline have been amazing. We had a queue down the street for open homes after a very successful advertising campaign and they have taken great care to review and recommend suitable tenants.</p>
          <p>Both Sahil and Madeline have provided excellent follow-up with all queries and commitments.</p>
          <p>I wouldn't hesitate to recommend them.</p>`,
    author: "Prue Stoneham"
  },
  {
    text: `<p>I am astonished by the level of professionalism and honesty your company has and have been practicing. This is all based on your experience and what you have noticed at the property, without us going through the issues and requesting. </p>
            <p>Thanks for everything especially negotiating with the landlord and ensuring good privacy for me and my family.</p>
            <p>Have a wonderful day and hats off for the level of service of Bricks & Mortar. </p>
            <p>We will recommend your agency to friends and family looking for real estate services based on what we have been experiencing even before shifting into the property. </p>`,
    author: "Gopinthran Sevalingam"
  },
  {
    text: `<p>I have dealt with Madeleine since she was at Nelson Alexander and she was a great Property Manager. Now that she has her own shop, I naturally brought my property under her management and she managed to get much higher rent than I ever expected!</p>`,
    author: "Tat Tsang"
  }
];
testimonials.map((testimonial, key) => {
  testimonial.id = key;
  return testimonial;
});
const testimonialGroups = chunk(testimonials, 3);

export default {
  data() {
    return {
      testimonials,
      testimonialGroups
    };
  },
  mounted() {
    $("#testimonialCarousel .carousel-inner .carousel-item:first").addClass("active");
  },
  methods: {
    truncate
  }
};
</script>
